import React from "react";
import {
  StyleSheet,
  View,
  Dimensions,
  ScrollView,
  TouchableOpacity,
  Text,
  Platform,
} from "react-native";

import AppConfig from "../../../config/AppConfig";
import {
  navigate,
  isWeb,
  setStorageItem,
  openURL,
} from "../../../helpers/utils";

import options from "./data";
import options_extra from "./data_extra";
import ImageComponent from "../common/ImageComponent";
import PageMoreHeader from "./PageMoreHeader";
import PageMoreCards from "./PageMoreCards";
import PageMoreFabButton from "./PageMoreFabButton";
import appStyles from "../../appStyles";
import CopyAppleIdDialog from "./CopyAppleIdDialog";
import TutorialsHelper from "../tutorials/TutorialsHelper";
import appPages from "../../../appPages";

const { height: HEIGHT } = Dimensions.get("window");

export default class PageMore extends React.Component {
  constructor(props) {
    super(props);
    this.controller = props.controller;
    this.state = { openIdDialog: false };
  }

  componentDidMount = () => {
    this.loadData();
  };

  loadData = () => {
    const oldData = this.controller.state?.more;
    if (oldData) {
      this.setDataModel(oldData);
    }

    // Check if newer version of data is available
    this.fetchApiData();
  };

  fetchApiData = () => {
    this.setState((state) => ({
      ...state,
      isLoading: true,
    }));

    this.setDataModel();
  };

  setDataModel = () => {
    this.setState((state) => ({ ...state, isLoading: false }));
  };

  // ------------------------------------- MESSAGES -------------------------------------
  showTempMessage = (message, duration = 3000) => {
    this.setState((state) => ({ ...state, message }));

    setTimeout(() => {
      this.setState((state) => ({ ...state, message: "" }));
    }, duration);
  };

  // ------------------------------------- ACTIONS -------------------------------------
  onPressHandler = (model) => {
    const { page, action, actionType = "changepage", page_args = {} } = model;

    setStorageItem("onboarding_started", page == appPages.onboardingPage);

    if (this.controller.navigation != null && AppConfig.USE_DRAWER) {
      this.controller.navigation.closeDrawer();
    }
    const isLogout = action != null && action.toLowerCase() === "logout";

    // Logout
    if (isLogout) {
      this.controller.logout();

      // Schedule Guide Call
    } else if (model.isScheduleGuideCall) {
      this.getCoaching();

      // Tutorials
    } else if (action == "tutorials") {
      TutorialsHelper.onTutorialClicked(this.controller, model);

      // Integrations
    } else if (action == "update_integrations") {
      if (this.controller.refreshIntegrations) {
        console.log("Refresh integrations data");
        this.controller.refreshIntegrations(true).then(() => {
          if (page) {
            navigate(this.controller, page, actionType, page_args);
          }
        });
      }
    } else {
      if (action) this.controller.cardAction({ action });
      if (page) {
        navigate(this.controller, page, actionType, page_args);
      }
    }
  };

  // ------------------------------------- COPY -------------------------------------
  confirmCopy = () => {
    this.toggleCopyDialog(false);
    this.showTempMessage("Copied to Clipboard", 1500);
  };

  toggleCopyDialog = async (isOpen) => {
    this.setState((state) => ({ ...state, openIdDialog: isOpen }));
  };

  getCoaching = () => {
    this.controller.tracking.track("Schedule Call");
    this.controller.navigation.closeDrawer();
    this.controller.cardActionWithCallback(
      {
        action: "save",
        target: "scheduled_call",
      },
      () => {
        openURL(AppConfig.COACHING_LINK);
      },
    );
  };

  render() {
    const { message, openIdDialog } = this.state;

    const version =
      AppConfig.DISPLAY_VERSION +
      (AppConfig.UPDATE_VERSION.length > 0
        ? "-" + AppConfig.UPDATE_VERSION
        : "");

    const { show_admin_tools, show_guide_tools } =
      this.controller.state?.settings || {};

    let menuOptions;
    //const allOptions = show_admin_tools ? [...options_extra, ...options] : options;
    const allOptions = options;
    // Admins
    if (!show_admin_tools && !show_guide_tools) {
      menuOptions = allOptions.filter(
        (o) => !o.isAdminOption && !o.isGuideOption,
      );
    } else if (show_guide_tools) {
      menuOptions = allOptions.filter(
        (o) => (!o.isAdminOption && !o.isGuideOption) || o.isGuideOption,
      );
    } else {
      menuOptions = allOptions;
    }

    return (
      <View
        style={[
          isWeb ? appStyles.container : { height: HEIGHT },
          styles.container,
        ]}
      >
        <PageMoreHeader
          controller={this.controller}
          toggleCopyDialog={this.toggleCopyDialog}
        />

        <ScrollView style={styles.scrollView}>
          {!isWeb ? <PageMoreCards controller={this.controller} /> : null}

          {menuOptions.map((parent) => (
            <View key={parent.id} style={styles.parent}>
              {parent.name ? (
                <Text style={styles.parentText}>{parent.name}</Text>
              ) : null}
              {parent.children.map((child) => (
                <TouchableOpacity
                  key={child.id}
                  style={styles.child}
                  onPress={() => this.onPressHandler(child)}
                >
                  {child.icon ? (
                    <ImageComponent
                      image={child.icon}
                      style={styles.imageIcon}
                    />
                  ) : child.iconTag ? (
                    <child.iconTag style={[styles.imageIcon]} />
                  ) : null}
                  <Text style={styles.childText}>{child.name}</Text>
                </TouchableOpacity>
              ))}
            </View>
          ))}
          <Text style={{ marginBottom: 50 }}> </Text>
        </ScrollView>

        <PageMoreFabButton mariOptions={{ mariMessage: message }} />

        {/* Copy Apple ID Dialog */}
        {openIdDialog ? (
          <CopyAppleIdDialog
            controller={this.controller}
            version={version}
            onConfirm={this.confirmCopy}
            onClose={() => this.toggleCopyDialog(false)}
          />
        ) : null}
      </View>
    );
  }
}

const styles = StyleSheet.create({
  container: {
    maxWidth: "100%",
  },
  scrollView: {
    flex: 1,
    paddingBottom: 100,
  },
  parent: {
    marginTop: 5,
    paddingLeft: 20,
  },
  parentText: {
    height: 20,
    fontFamily: Platform.select({
      default: "Montserrat",
      android: "Montserrat-SemiBold",
    }),
    fontWeight: "600",
    fontSize: 14,
    lineHeight: 17,
    letterSpacing: 0.175,
    color: "#2D3142",
    opacity: 0.6,
    display: "flex",
    alignItems: "center",
  },
  child: {
    height: 44,
    paddingLeft: 14,
    display: "flex",
    alignItems: "center",
    flexDirection: "row",
  },
  childText: {
    fontFamily: Platform.select({
      default: "Montserrat",
      android: "Montserrat-Regular",
    }),
    fontSize: 14,
    lineHeight: 17,
    letterSpacing: 0.175,
    color: "#2D3142",
    display: "flex",
    alignItems: "center",
  },
  imageIcon: {
    width: 30,
    height: 30,
    marginRight: 10,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
});
